import React, { useEffect, useState } from 'react';
import "./WhyChooseUs.css";

function WhyChooseUs () {
    let [ mobile, setMobile ] = useState( false );

    useEffect( () => {
        window.scrollTo( 0, 0 );
        if ( document.getElementById( "root" ).clientWidth < 600 ) {
            setMobile( true );
        }
    }, [] );

    return (
        <div className='about-container'>
            <div className='products-banner'>
                {!mobile && <img src={require( "../../images/quality/banner.avif" )} alt="quality-banner" height={"100%"} width={"100%"} />}
                {mobile && <img src={require( "../../images/quality/banner-mobile.avif" )} alt="quality-banner" height={"100%"} width={"100%"} />}
                <div className='products-banner-content'>
                    <span>Why Choose Us</span>
                    <span>Soar to New Heights with Our Aerospace-Grade Fasteners</span>
                </div>
            </div>
            <div className='about-header'>
                Reliable Solutions for Critical Aerospace Grade Applications
            </div>
            <div className='about-content'>
                At Aerospace Fasteners Pvt. Ltd., we understand the unique demands of the aerospace and defense industry. That's why we offer a comprehensive range of aerospace-grade fasteners designed to meet the highest standards of quality, reliability, and performance.
            </div>
            <div className='about-middle'>
                <img src={require( "../../images/why_choose_us/image.avif" )} alt="quality-middle" height={"100%"} width={"100%"} />
                <div className='about-middle-content'>
                    <div style={{ fontWeight: "700" }}>
                        Our fasteners are engineered to withstand the extreme conditions of flight, including:
                    </div>
                    <ul>
                        <li>High Temperatures</li>
                        <li>Corrosive Environments</li>
                        <li>Vibration and Stress</li>
                    </ul>
                </div>
            </div>
            {/* <div className='about-content' style={{ gap: "1rem" }}>
                <div className='about-content-header'>Featured Products:</div>
                <ul>
                    <li><b>Hi-Lok Fasteners: </b>Ideal for higher-strength applications.</li>
                    <li><b>NAS Bolts and Screws: </b>Precision and reliability for critical needs.</li>
                    <li><b>Titanium Fasteners: </b>Lightweight and corrosion-resistant solutions.</li>
                </ul>
            </div> */}
            <div className='about-content' style={{ gap: "1rem" }}>
                <div className='about-content-header'>Benefits:</div>
                <ol>
                    <li><b>Unmatched Reliability and Consistency: </b>Our products are rigorously tested to ensure they perform under the most demanding conditions.
                    </li>
                    <li><b>Expertly Engineered: </b>Designed specifically for aerospace applications, our fasteners offer superior performance.
                    </li>
                    <li><b>Custom Solutions: </b>We tailor our products to meet your unique needs, ensuring the best fit for your projects.
                    </li>
                </ol>
            </div>
            <div className='about-content' style={{ gap: "1rem" }}>
                <div className='about-content-header'>Call-to-Action:</div>
                <span>
                    Explore our aerospace-grade fasteners today and discover the difference. Our expertise and quality products have helped us achieve unparalleled success with many aerospace and defense customers worldwide.
                </span>
            </div>
            <div className='about-content' style={{ gap: "1rem" }}>
                <div className='about-content-header'>Unscrew the Competition: Choose Aero Fasteners for Your Fastener Needs</div>
                <span>
                    Choosing the right fastener is critical in the aerospace industry. At Aerospace Fasteners Pvt. Ltd., we are committed to providing the best solutions for your needs. Our dedication to quality and innovation sets us apart, making us the preferred choice for industry leaders.
                </span>
            </div>
            <div className='about-content' style={{ gap: "1rem" }}>
                <div className='about-content-header'>Get a Grip on Quality: Stick to Aero Fasteners for Better Hold</div>
                <span>
                    Quality is our hallmark. At Aerospace Fasteners Pvt. Ltd., we ensure that every fastener meets stringent quality standards, giving you the assurance you need for your critical applications. Trust Aero Fasteners for a firm hold on quality and performance.

                </span>
            </div>
            <div className='about-content' style={{ gap: "1rem" }}>
                <div className='about-content-header'>Why Choose Aerospace Fasteners Pvt. Ltd. ?</div>
                <ul>
                    <li><b>Industry Expertise: </b>With years of experience serving the aerospace and defense sectors, we understand your challenges and requirements.
                    </li>
                    <li><b>High-Performance Products: </b>Our fasteners are designed to excel in extreme conditions, ensuring safety and reliability.
                    </li>
                    <li><b>Customized Solutions: </b>We work closely with you to develop fasteners that meet your specific needs, providing a perfect fit for your applications.
                    </li>
                    <li><b>Global Reach: </b>Our products are trusted by aerospace and defense companies worldwide, reflecting our commitment to excellence.
                    </li>
                    <li><b>Customer Support: </b>Our dedicated team is here to support you at every step, from product selection to post-sales service.
                    </li>
                </ul>
            </div>
            <div className='about-content'>
                Explore our range of aerospace-grade fasteners and experience the Aero Fasteners difference. Contact us today to learn more about how we can support your next project with our top-quality products and exceptional service.
            </div>
        </div>
    )
}

export default WhyChooseUs
